import {
    EnvironmentProviders,
    importProvidersFrom,
    InjectionToken,
    isDevMode,
    makeEnvironmentProviders
} from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@env/environment';

export const LOCALE_ID_SW = new InjectionToken<string>('vi');

/**
 * Get locale from URL
 *
 * @return {*}  {string}
 */
function getLocale(): string {
    if (typeof window !== 'undefined') {
        return window?.location?.pathname?.includes('/vi/') ? 'vi' : 'en';
    }
    return 'vi';
}

/**
 * Check if the app is running in the in-app browser
 *
 * @return {*}  {boolean}
 */
function isInAppBrowser(): boolean {
    let userAgent = '';
    if (typeof navigator !== 'undefined') {
        userAgent = navigator.userAgent || navigator.vendor;
    }
    if (typeof window !== 'undefined' && 'opera' in window && !userAgent) {
        userAgent = (window.opera as string) ?? '';
    }
    return /FBAN|FBAV|Instagram|Zalo/.test(userAgent);
}

/**
 * Provide SW Config
 *
 * @export
 * @return {*}  {EnvironmentProviders}
 */
export function provideSwConfig(): EnvironmentProviders {
    return makeEnvironmentProviders([
        importProvidersFrom(
            ServiceWorkerModule.register(`/${getLocale()}/ngsw-worker.js`, {
                enabled: !isDevMode() && !isInAppBrowser() && !environment.options.isSSRMode,
                registrationStrategy: 'registerWhenStable:30000',
            })
        ),
        {
            provide: LOCALE_ID_SW,
            useFactory: getLocale,
        },
    ]);
}
